// extracted by mini-css-extract-plugin
module.exports = {"root":"ClassicHome_root__T6OeQ","button":"ClassicHome_button__mSDwX","date":"ClassicHome_date__HKRUq","logo":"ClassicHome_logo__8BFzQ","logoSvg":"ClassicHome_logoSvg__Sdkyx"};